import React, { useState } from 'react';
import LandingPage from './components/home/LandingPage';
import WildernessPsychotherapyPage from './components/therapy/WildernessPsychotherapyPage';
import GroupWildernessTherapyPage from './components/therapy/GroupWildernessTherapyPage';
import MovementCoachingPage from './components/therapy/MovementCoachingPage';
import CorporateWellbeingPage from './components/therapy/CorporateWellbeingPage';

function App() {
  const [currentPage, setCurrentPage] = useState('home');
  
  // Keep current page in sync globally so Navbar can access it
  window.currentPage = currentPage;

  // Make this function available globally so it can be called from anywhere
  window.navigateTo = (page, section) => {
    setCurrentPage(page);
    
    if (section) {
      // Scroll to section after a brief delay to allow page to render
      setTimeout(() => {
        const element = document.getElementById(section);
        if (element) {
          const offset = 80; // Match navbar offset
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  };

  return (
    <div className="App">
      {currentPage === 'home' && <LandingPage />}
      {currentPage === 'wilderness-therapy' && <WildernessPsychotherapyPage />}
      {currentPage === 'group-wilderness-therapy' && <GroupWildernessTherapyPage />}
      {currentPage === 'movement-coaching' && <MovementCoachingPage />}
      {currentPage === 'corporate-wellbeing' && <CorporateWellbeingPage />}
    </div>
  );
}

export default App;